
import * as classNames from "classnames"
import { AddCommentFormRenderProps } from "../../article/componentas/articleComments/addCommentFormWrapper";
import { disablePageRefresh, enablePageRefresh } from "../../../siteWidgets/siteWidgetUtils";
import { getTranslation } from "../../article/componentas/articleComments/translations";


interface AddCommentFormProps {
    props: AddCommentFormRenderProps

}

export class MobileAddCommentFormUIGalhed extends React.Component<AddCommentFormProps, {}> {



    handleInputFocus = () => {
        disablePageRefresh()
    }

    handleInputOutOfFocus = () => {
        enablePageRefresh()
    }

    private handleclosePopUp = () => {
        const { onClosePopUp, handleCloseCommentForm, resetFormData } = this.props.props
        onClosePopUp()
          handleCloseCommentForm()
        resetFormData()
    }

    private getTermsLinkByLang = (lang: string) => {
        if (lang === "he") return "https://www.ynet.co.il/article/bkswwa3sn";
        else if (lang === "ru") return "https://www.vesty.co.il/articles/0,7340,L-4867560,00.html";
        else return "https://www.ynetnews.com/article/bkh7s3p7t"
    }

    render() {
        const { isSent, name, comment, isPopUpOpened,
            lang, onInputChanged, handleCommentSend, onClosePopUp, roof, profileImageSrc, soldierName, isNewDesign,
            nameError, commentError } = this.props.props

        const AddCommentFormClasses = classNames({
            "AddCommentFormGalhed": true,
            "AddCommentFormGalhedRedesign": isNewDesign,
            "fadeIn": isPopUpOpened,
            "hide": !isPopUpOpened,
        })

        let term1 = " אין לשלוח תגובות הכוללות מידע המפר את";
        let term2 = "תנאי השימוש של Ynet";
        let term3 = " לרבות דברי הסתה, דיבה וסגנון החורג מהטעם הטוב.";
        if (lang === "en") {
            term1 = "The commenter agrees to the privacy policy of Ynet News and agrees not to submit comments that violate the ";
            term2 = "terms of use";
            term3 = ", including incitement, libel and expressions that exceed the accepted norms of freedom of speech.";
        }
        if (lang === "ru") {
            term1 = "Автор комментария принимает Условия конфиденциальности Вести и соглашается не публиковать комментарии, нарушающие ";
            term2 = "Правила использования";
            term3 = ",  в том числе подстрекательство, клевету и выходящее за рамки приемлемого в определении свободы слова.";
        }


        return (
            <div className={AddCommentFormClasses}>
                <div className="PopUpButtonClose" onClick={this.handleclosePopUp}>
                {isNewDesign &&  <span className="popUpCloseX"></span>}
                </div>
                <div className="AddCommentForm" >

                    {isNewDesign ? 
                       <div className="commentsTabHeader">
                          <div className="maintitle">{getTranslation(lang, "Each person is a world unto themselves")}</div>
                          <div className="subTitle"> {getTranslation(lang, "Add a personal dedication on the memorial wall")}</div>
                       </div>
                    :
                       <div className="formTopArea">
                          <img className="profileImage" src={profileImageSrc} alt="Profile Image" />
                          <div className="profileDetails">
                          <div className="soldatRoof">{roof}</div>
                          <div className="soldatTitle">{soldierName}</div>
                          </div>
                       </div>
                    }

                    {!isSent &&
                        <>

                            <input
                                className="userDetailsInput inputStyle"
                                maxLength={20}
                                value={name}
                                name="commenterName"
                                placeholder={getTranslation(lang, "Full Name")}
                                onChange={(e) => onInputChanged(e, "name")}
                                onFocus={this.handleInputFocus}
                                onBlur={this.handleInputOutOfFocus}
                            />
                             {isNewDesign && <span className="errorMessage">{nameError}</span>} 

                            <textarea
                                className="comment inputStyle"
                                type="text" maxLength={4000}
                                value={comment}
                                name="commentContent"
                                resize="vertical"
                                placeholder={getTranslation(lang, "Write your dedication")}
                                onChange={(e) => onInputChanged(e, "comment", true)}
                                onFocus={this.handleInputFocus}
                                onBlur={this.handleInputOutOfFocus}
                            >
                            </textarea>
                            {isNewDesign && <span className="errorMessage">{commentError}</span>} 
                            
                            {isNewDesign && 
                            <div className="termsOfService">
                            {term1}
                            <a href={this.getTermsLinkByLang(lang)} target="_blank" title={getTranslation(lang, "terms of use")} style={{ margin: "auto 5px" }} >{term2}</a>
                            {term3}
                            </div>} 

                            <button className="sendBtn" id="addCommentSendButton" title={getTranslation(lang, "Send your dedication")} onClick={e => handleCommentSend()}>
                                <span>{getTranslation(lang, "Send your dedication")}</span>
                               {isNewDesign && <span className="arrow"></span>}  
                            </button>

                        </>}

                    {isSent && <div className="commentSentMessageWrapper">
                        <div className="thankYouWrapper">

                            <div className="thankYou"><strong >{getTranslation(lang, "Thank you for adding to the memory wall")},</strong> <span>{getTranslation(lang, "Your response has been submitted for approval and will be published subject to the system's considerations.")}</span></div>
                            <button className="sendBtn" title={getTranslation(lang, "Back to soldier page")} onClick={this.handleclosePopUp}>
                                {isNewDesign ? (
                                    <>
                                        <span>{getTranslation(lang, "Add a new dedication")}</span>
                                        <span className="arrow"></span>
                                    </>
                                ) : (
                                    getTranslation(lang, "Back to soldier page")
                                )}
                            </button>
                        </div>
                    </div>}
                </div>

            </div>
        )
    }
}